import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { ArrowRight, Shield, Zap, Users } from 'lucide-react';
import { mockData } from '../data/mock';

const Hero = () => {
  const { hero } = mockData;

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-blue-50 py-20 lg:py-28">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-grid-slate-100 [mask-image:linear-gradient(0deg,#fff,rgba(255,255,255,0.6))] -z-10" />
      
      <div className="container mx-auto px-4">
        <div className="mx-auto max-w-4xl text-center">
          {/* Badge */}
          <div className="mb-8">
            <Badge variant="secondary" className="px-4 py-1.5 text-sm">
              <Zap className="w-4 h-4 mr-2" />
              Trusted by 150+ operators worldwide
            </Badge>
          </div>

          {/* Company Name */}
          <div className="mb-4">
            <h2 className="text-2xl font-semibold text-gray-700 tracking-wide">
              WINNEX PRO SERVICES
            </h2>
          </div>

          {/* Main heading */}
          <h1 className="mb-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl lg:text-7xl">
            {hero.title}
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-500">
              {hero.subtitle}
            </span>
          </h1>

          {/* Description */}
          <p className="mb-10 text-xl text-gray-600 max-w-2xl mx-auto">
            {hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700 text-lg px-8 py-3 h-auto">
              {hero.primaryCTA}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button size="lg" variant="outline" className="text-lg px-8 py-3 h-auto">
              {hero.secondaryCTA}
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-3">
              <div className="p-2 bg-blue-100 rounded-lg">
                <Users className="w-6 h-6 text-blue-600" />
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-gray-900">{hero.trustBadges.operators}</div>
                <div className="text-sm text-gray-600">Operators</div>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3">
              <div className="p-2 bg-green-100 rounded-lg">
                <Shield className="w-6 h-6 text-green-600" />
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-gray-900">{hero.trustBadges.uptime}</div>
                <div className="text-sm text-gray-600">Uptime SLA</div>
              </div>
            </div>
            
            <div className="flex items-center justify-center space-x-3">
              <div className="p-2 bg-purple-100 rounded-lg">
                <Zap className="w-6 h-6 text-purple-600" />
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-gray-900">{hero.trustBadges.studios}</div>
                <div className="text-sm text-gray-600">Game Studios</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;